import styled from '@emotion/styled';

export const Autocomplete = styled.div`
  input {
    width: 30rem;
    background: white !important;
  }
`;

export const Suggestions = styled.ul`
  top: 100%;
  left: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  overflow: auto;
  max-height: 20rem;
`;
